import { ICON_DEFAULT_COLOR } from '@constants/icons';
import { IconProps } from '@models/icons';

function PencilFill({ size = 16, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path transform="translate(2 2)"
                d="M4.1766 10.751C3.99338 10.9115 3.7579 10.9995 3.51433 10.9987L1.14156 10.9907C0.536989 10.9886 0.0724911 10.4547 0.154105 9.85568L0.478772 7.47266C0.511339 7.23363 0.629219 7.01442 0.810683 6.85546L7.87854 0.663932C8.29619 0.298067 8.93193 0.342496 9.29463 0.762897L11.3516 3.14714C11.7105 3.5631 11.6666 4.19066 11.2534 4.55263L4.1766 10.751Z"
                fill={color}/>
        </svg>
    );
}

export default PencilFill;
